/**
 * Creates a script tag with attributes
 * Whether or not to embed the script in the body or in the head
 *
 * @param {object} attributes - Key Value pairs of attributes to add to the script tag
 * @param {(boolean|string)} [embedTarget=false] - DOM element for embedding script. Must be a valid dom element like 'head' or 'body'
 * @returns ScriptTag | null
 */
function createScript({ attributes, embedTarget = false }) {
  if (document) {
    const s = document.createElement('script');
    Object.keys(attributes).forEach(key => {
      s[key] = attributes[key];
    });
    if (embedTarget) {
      document[embedTarget].appendChild(s);
      return s;
    }
  }
  return null;
}

export default createScript;
